import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Fusionne des classes Tailwind en résolvant les conflits (la dernière gagne).
 * Attendu par tous les composants générés par la CLI shadcn-vue.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
